
export default [
    {
        path: 'platform',
        component: resolve => require(['@/views/platform'], resolve),
        name: 'Platform',
        keepAlive: true,
        meta: {
            nav: '公共支撑平台'
        }
    }
      
]


// WEBPACK FOOTER //
// ./src/router/platform.js